import { ADVICE_REQUESTS_ENDPOINT } from 'common/constants'
import { MutationSetLastVisitedArgs } from 'common/graphql/schemaDefinition'
import { request } from 'common/utils'

import query from '../graphql/setLastVisited.graphql'
import { SetLastVisitedMutation } from '../interfaces'

export const setLastVisited = async (variables: MutationSetLastVisitedArgs): Promise<SetLastVisitedMutation> =>
  request<SetLastVisitedMutation>(ADVICE_REQUESTS_ENDPOINT, query, variables)
